import TextBubbles from '@/pages/home/components/TextBubbles';
import React, { useMemo } from 'react';
import { Menu } from 'tea-component';
import MenuPopover from './MenuPopover';
import {
  getFilterValueStorage,
  saveFilterName,
  setSessionStorage,
} from '../../FilterCommon/utils/storage';
import { useDispatch, useHistory } from 'umi';
import { changePageLoading } from '@/pages/opinion/utils/data';
import {
  getGPTDateType,
  getGptStoreKey,
  setGPTStore,
} from '@/pages/opinion/utils/storageUtils';
import { DBO_POINT } from '@op/operationLog/buriedPoint';

export default function FavoritesMenuItem({
  item,
  userInfo,
  gameInfo,
  wholeGameInfo,
  favoritesMenuList,
  index,
  sortCallback,
  deleteCallback,
  isSelected,
  menuFilterInfo,
  loading,
  addCallback,
}: any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isGpt = useMemo(() => {
    return item.assembly_url === '/opinion/gpt/GPT%20Auto%20Report';
  }, [item]);
  const { filterDefaultValue, defaultSelectedFilter } = useMemo(() => {
    let filterDefaultValue = {};
    let defaultSelectedFilter = [];
    const { filter_settings } = menuFilterInfo;

    try {
      const { filter, selectedFilter } = JSON.parse(filter_settings);
      if (isGpt) {
        const { date_type, ...otherInfo } = filter;
        filterDefaultValue = {
          ...otherInfo,
          kind: 1,
          type: getGPTDateType(date_type),
        };
      } else {
        filterDefaultValue = filter;
      }

      defaultSelectedFilter = selectedFilter;
    } catch (error) {}

    const defaultFilterValue: any = { ...filterDefaultValue };
    return {
      filterDefaultValue: defaultFilterValue,
      defaultSelectedFilter,
    };
  }, [menuFilterInfo]);

  return (
    <Menu.Item
      key={item.id}
      selected={isSelected}
      className="my-favorite-page-menu"
      onClick={() => {
        saveFilterName(gameInfo);
        const { edition_unified_id } = gameInfo;
        if (isGpt) {
          setGPTStore(
            {
              ...filterDefaultValue,
              date_type: filterDefaultValue?.type || 'daily',
            } as any,
            getGptStoreKey(1, edition_unified_id),
          );
        } else {
          const sessionFilter = getFilterValueStorage(gameInfo);
          const { start_time, end_time, date_type } = sessionFilter || {};
          let realFilterDefaultValue = filterDefaultValue;
          if (start_time && end_time && date_type) {
            realFilterDefaultValue = {
              ...filterDefaultValue,
              date_type,
              start_time,
              end_time,
            };
          }
          // 其他页面直接设置缓存
          setSessionStorage(realFilterDefaultValue, gameInfo, true);
        }
        // 跳转
        history.push(item.assembly_url, { reportName: item.name_en });
        changePageLoading(dispatch);
 


        DBO_POINT.btnOri('favorite', {
          extInfo: JSON.stringify({ gameid: edition_unified_id }),
          extInfo2: item.assembly_url
        });
      }}
      title={
        <div className="left-nav-text-hd">
          <TextBubbles className="menu-context-text" text={item.name_en} />
          <MenuPopover
            FavoritesType
            userInfo={userInfo}
            id={item.id}
            menuItem={item}
            sortCallback={sortCallback}
            gameInfo={gameInfo}
            wholeGameInfo={wholeGameInfo}
            deleteCallback={deleteCallback}
            upDisable={index === 0}
            selectedFilter={defaultSelectedFilter}
            filterDefaultValue={filterDefaultValue}
            loading={loading}
            downDisable={index + 1 === favoritesMenuList.length}
            editInfo={menuFilterInfo}
            addCallback={addCallback}
          />
        </div>
      }
    />
  );
}
